import React, { useEffect, useState, createContext, useContext } from 'react';
export type Workspace = 'admin' | 'student';
interface WorkspaceContextType {
  workspace: Workspace;
  setWorkspace: (w: Workspace) => void;
}
const WorkspaceContext = createContext<WorkspaceContextType>({
  workspace: 'admin',
  setWorkspace: () => {}
});
export function WorkspaceProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [workspace, setWorkspaceState] = useState<Workspace>(() => {
    try {
      const stored = localStorage.getItem('dss-workspace');
      return (stored === 'student' ? 'student' : 'admin') as Workspace;
    } catch {
      return 'admin';
    }
  });
  const setWorkspace = (w: Workspace) => {
    setWorkspaceState(w);
    try {
      localStorage.setItem('dss-workspace', w);
    } catch {}
  };
  return <WorkspaceContext.Provider value={{
    workspace,
    setWorkspace
  }} data-id="element-180">
      {children}
    </WorkspaceContext.Provider>;
}
export function useWorkspace() {
  return useContext(WorkspaceContext);
}